// extracted by mini-css-extract-plugin
var _1 = "awhXKyWdrgGcIseODIAw";
var _2 = "M4dN4TfvQNYRNtuRk2Nt";
export { _1 as "footer", _2 as "section" }
